// Catalogue des tags de "Mes Désirs" — FR/EN seulement (comme les pages du Centre des règles,
// LegalLayout.tsx : un contenu aussi long n'a pas besoin des 12 langues du reste de l'app pour
// une première version, le FR fait foi). Vocabulaire volontairement élégant, jamais vulgaire.
export interface DesireTag { key: string; labelFr: string; labelEn: string }
export interface DesireCategory { key: string; i18nTitleKey: string; tags: DesireTag[] }

export const GARDEN_DESIRE_CATEGORIES: DesireCategory[] = [
  {
    key: "connection", i18nTitleKey: "garden_desires_cat_connection",
    tags: [
      { key: "romance", labelFr: "Romance", labelEn: "Romance" },
      { key: "seduction", labelFr: "Séduction", labelEn: "Seduction" },
      { key: "intimacy", labelFr: "Intimité", labelEn: "Intimacy" },
      { key: "tenderness", labelFr: "Tendresse", labelEn: "Tenderness" },
      { key: "complicity", labelFr: "Complicité", labelEn: "Complicity" },
      { key: "deep_connection", labelFr: "Connexion profonde", labelEn: "Deep connection" },
      { key: "passionate_relationship", labelFr: "Relation passionnelle", labelEn: "Passionate relationship" },
      { key: "emotional_relationship", labelFr: "Relation affective", labelEn: "Emotional relationship" },
      { key: "moments_a_deux", labelFr: "Moments à deux", labelEn: "Moments together" },
    ],
  },
  {
    key: "exploration", i18nTitleKey: "garden_desires_cat_exploration",
    tags: [
      { key: "new_experiences", labelFr: "Nouvelles expériences", labelEn: "New experiences" },
      { key: "fantasies", labelFr: "Fantasmes", labelEn: "Fantasies" },
      { key: "roleplay", labelFr: "Jeux de rôle", labelEn: "Roleplay" },
      { key: "exploring_together", labelFr: "Exploration à deux", labelEn: "Exploring together" },
      { key: "gradual_discovery", labelFr: "Découverte progressive", labelEn: "Gradual discovery" },
      { key: "bdsm", labelFr: "BDSM", labelEn: "BDSM" },
      { key: "domination", labelFr: "Domination", labelEn: "Domination" },
      { key: "submission", labelFr: "Soumission", labelEn: "Submission" },
      { key: "role_exploration", labelFr: "Exploration des rôles", labelEn: "Role exploration" },
      { key: "curiosity", labelFr: "Curiosité", labelEn: "Curiosity" },
    ],
  },
  {
    key: "dynamics", i18nTitleKey: "garden_desires_cat_dynamics",
    tags: [
      { key: "exclusive_relationship", labelFr: "Relation exclusive", labelEn: "Exclusive relationship" },
      { key: "open_relationship", labelFr: "Relation ouverte", labelEn: "Open relationship" },
      { key: "couple", labelFr: "Couple", labelEn: "Couple" },
      { key: "meeting_single", labelFr: "Rencontre avec une personne seule", labelEn: "Meeting someone single" },
      { key: "group_discovery", labelFr: "Découverte à plusieurs", labelEn: "Group discovery" },
      { key: "friendly_with_intimacy", labelFr: "Relation amicale avec possibilité d'intimité", labelEn: "Friendly relationship with possible intimacy" },
      { key: "romantic_relationship", labelFr: "Relation romantique", labelEn: "Romantic relationship" },
      { key: "no_strings", labelFr: "Relation sans engagement", labelEn: "No-strings relationship" },
      { key: "privileged_connection", labelFr: "Connexion privilégiée", labelEn: "Privileged connection" },
    ],
  },
  {
    key: "sensuality", i18nTitleKey: "garden_desires_cat_sensuality",
    tags: [
      { key: "massage", labelFr: "Massage", labelEn: "Massage" },
      { key: "physical_contact", labelFr: "Contact physique", labelEn: "Physical contact" },
      { key: "seduction_games", labelFr: "Jeux de séduction", labelEn: "Seduction games" },
      { key: "romantic_atmosphere", labelFr: "Ambiance romantique", labelEn: "Romantic atmosphere" },
      { key: "sensuality", labelFr: "Sensualité", labelEn: "Sensuality" },
      { key: "slowness", labelFr: "Lenteur", labelEn: "Slowness" },
      { key: "spontaneity", labelFr: "Spontanéité", labelEn: "Spontaneity" },
      { key: "closeness", labelFr: "Proximité", labelEn: "Closeness" },
      { key: "affection", labelFr: "Affection", labelEn: "Affection" },
    ],
  },
];

export type DesireLevel = "like" | "curious" | "discover" | "private";
export const DESIRE_LEVELS: DesireLevel[] = ["like", "curious", "discover", "private"];
export const DESIRE_LEVEL_I18N_KEY: Record<DesireLevel, string> = {
  like: "garden_tag_like", curious: "garden_tag_curious", discover: "garden_tag_discover", private: "garden_tag_private",
};
